<div *ngIf="isLoading == true; else hasLoaded">
  <app-spinner></app-spinner>
</div>
<ng-template #hasLoaded>
  <div class="PO Inventory">
    <mat-card class="sticky invWrapper shadow-none">
      <div class="fx-xs-column fx-row fx-align-space-between-center">
        <div class="fx-row fx-align-start-center fx-flex-30" id="header__wrapper">
          <app-count-header title="{{inventory?.invBatchName}}"></app-count-header>
        </div>
        <h2 class="text-center w-100">{{ "byCategory" | translate }}</h2>
        <div class="flex fx-align-end-center fx-flex-30">
          <div class="fx-layout-lt-md-column fx-row fx-gap-20px">
            <button mat-raised-button color="primary" (click)="sendReport()" class="fx-align-simple-center">
              {{ "sendReport" | translate }}
            </button>
            <app-select-report></app-select-report>
            <button mat-raised-button color="primary" (click)="generatePDF()" class="fx-align-simple-center">
              {{ "generatePDF" | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-card>
    <app-mid-header [inventory]="inventory"></app-mid-header>
    <div class="fx-row p-15">
      <div class="fx-flex-50 fx-hide fx-show-sm fx-show-md fx-show-lg fx-show-xl"></div>
      <form [formGroup]="prdMinQtyForm" class="fx-xs-flex-100 fx-flex-50 fx-xs-column fx-row fx-align-end-center">
        <div class="fx-row fx-align-end-center">
          <mat-radio-group formControlName="prdMinQty" 
            [value]="settings$.locEnableMultiMinQty == 0 ? 0 : 1" 
            (change)="setMinQty($event)"
            class="fx-xs-row fx-align-space-between-center countType__radio-group form-control w-100">
            <div class="fx-row radio-btn-1">
              <mat-radio-button class="countType__radio-button radio-button2" [value]="0" *ngIf="mls1Option">
                <span>{{ settings$?.locMinQtyLabel1 }}</span>
              </mat-radio-button>
            </div>
            <mat-radio-button class="countType__radio-button" [value]="1" *ngIf="settings$?.locEnableMultiMinQty == 1 && mls2Option">
              <span>{{ settings$?.locMinQtyLabel2 }}</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </form>
    </div>
    <br />
    <br />
    <table width="100%" *ngFor="let d of inventoryItems; let i = index; " class="Table--stacked">
      <thead *ngIf="d.data?.length != 0">
        <tr class="main-header">
          <mat-toolbar color="white" class="fx-row fx-align-center">
            <span [innerHTML]="d.prdCatNameEn"></span>
          </mat-toolbar>
        </tr>
      </thead>
      <tbody *ngIf="d.data?.length != 0">
        <tr>
          <td>
            <table class="inner-table">
              <thead>
                <tr>
                  <th>
                    {{ "products.table.prdCode" | translate }}
                  </th>
                  <th>
                    {{ "products.table.prdNameEn" | translate }}
                  </th>
                  <th>
                    UOM
                  </th>
                  <th class="text-center" *ngIf="mls1Option">
                    {{ prdMinQtyValue == "0" ? settings$.locMinQtyLabel1 : settings$.locMinQtyLabel2 }}
                  </th>
                  <th class="text-center">
                    {{ "count" | translate }}
                  </th>
                  <th class="text-center">
                    {{ "products.table.order" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of d.data;" class="fx-xs-row-wrap table-row pointer" appInventoryRow [prdID]="item.prdID" [invitmID]="item.invitmID">
                  <td class="fx-xs-flex-100 fx-xs-row fx-align-xs-space-between-center">
                    <span class="mobile-label">{{ "products.table.prdCode" | translate }}</span>
                    <span [innerHTML]="item.prdCode"></span>
                  </td>
                  <td class="fx-xs-flex-100 fx-xs-row  fx-align-xs-space-between-center">
                    <span class="mobile-label">{{ "products.table.prdNameEn" | translate }}</span>
                    <span [innerHTML]="item.prdNameEn"></span>
                    <span *ngIf="item.isCombined" style="color: red;"> *</span>
                  </td>
                  <td class="fx-xs-flex-100 fx-xs-row fx-align-xs-space-between-center">
                    <span class="mobile-label">UOM</span>
                    <span>{{item.prdCasePack}}</span>
                  </td>
                  <td class="text-center fx-align-xs-space-between-center" *ngIf="mls1Option">
                    <span class="mobile-label">Build To</span>
                    <span *ngIf="prdMinQtyValue == '0'; else elseBlock">
                      <span>{{ parseInt(item.countType?.pcmMinQty1) }}</span>
                    </span>
                    <ng-template #elseBlock>
                      <span>{{ parseInt(item.countType?.pcmMinQty2) }}</span>
                    </ng-template>
                  </td>
                  <td class="text-center fx-align-xs-space-between-center">
                    <span class="mobile-label">Count</span>
                    <span>{{ item.onHand > 0 ? item.onHand.toFixed(2) : '/'}}</span>
                  </td>
                  <td class="text-center error fx-align-xs-space-between-center">
                    <span class="mobile-label">Order</span>
                    <span *ngIf="prdMinQtyValue == '0'; else elseBlock">
                      <span [ngClass]="onRound(item.onOrderMin1.toFixed(2) > 0) ? 'red' : ''">
                        {{onRound((item.countType?.pcmMinQty1-item.onHand).toFixed(2))}}
                      </span>
                    </span>
                    <ng-template #elseBlock>
                      <span [ngClass]="onRound(item.onOrderMin1.toFixed(2) > 0) ? 'red' : ''">
                        {{onRound((item.countType?.pcmMinQty2-item.onHand).toFixed(2))}}
                      </span>
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="bottom-table alert-message" *ngIf="hasAsteriskProducts">
      <tr>
        <td>{{ "message_asterisk" | translate }}</td>
      </tr>
    </table>
    <table class="bottom-table alert-message" *ngIf="!dataLength">
      <tr>
        <td>{{ "count.no_categories_product" | translate }}</td>
      </tr>
    </table>
  </div>
</ng-template>
